import React, { useEffect, useState } from 'react';
import { LoadingSpinner } from '@qualtrics/ui-react';
import {
  getEvaluationPage,
  getEvaluationTasks,
  isRetakeLinksEnabled,
  isCustomTextEnabledService
} from '../services/evaluationPageService';
import { getStudentByHashedStudentId } from '../services/studentService';
import HomePage from '../HomePage/homePage';
import EvaluationExperience from '../EvaluationExperience/evaluationExperience';
import styles from './evaluationExperienceStudentPortal.module.css';

const brandId = document.getElementById('bId').textContent;
const hashedStudentId = document.getElementById('uId').textContent;
const language = document.getElementById('language').textContent;
const DEFAULT_BROWSER_TITLE = "Qualtrics Course Evaluations - Student Portal";

const EvaluationExperienceStudentPortal = () => {
  const [evaluationPage, setEvaluationPage] = useState({});
  const [evaluationTasks, setEvaluationTasks] = useState([]);
  const [areRetakesEnabled, setAreRetakesEnabled] = useState(undefined);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [studentId, setStudentId] = useState('');
  // Evaluation to be used for evaluation experience
  const [selectedEvaluation, setSelectedEvaluation] = useState(undefined);
  const [isCustomTextEnabled, setCustomTextEnabled] = useState(undefined);

  useEffect(() => {
    const getEvaluationData = async () => {
      const evaluationPagePromise = getEvaluationPage(
        brandId,
        hashedStudentId,
        language
      );
      const evaluationTasksPromise = getEvaluationTasks(
        brandId,
        hashedStudentId,
        language
      );
      const retakesEnabledPromise = isRetakeLinksEnabled(brandId);
      const customTextEnabledPromise = isCustomTextEnabledService(brandId);
      const studentPromise = getStudentByHashedStudentId(hashedStudentId, brandId);
      const [evaluationPage, evaluationTasks, retakeLinksEnabled, customTextEnabled, student] = await Promise.all([
        evaluationPagePromise,
        evaluationTasksPromise,
        retakesEnabledPromise,
        customTextEnabledPromise,
        studentPromise
      ]);
      setEvaluationPage(evaluationPage);
      setEvaluationTasks(evaluationTasks);
      setAreRetakesEnabled(retakeLinksEnabled);
      setCustomTextEnabled(customTextEnabled);
      setStudentId(student["userId"]);
      setIsPageLoading(false);
      document.title = evaluationPage.browserTitleText !== null
                ? evaluationPage.browserTitleText
                : DEFAULT_BROWSER_TITLE;
    };

    getEvaluationData();
  }, []);

  const onSurveySubmission = (transactionId) => {
    blockEvaluationTaskAndSetToCompleted(transactionId);
    setTimeout(() => {
      unblockEvaluationTask(transactionId);
    }, 5000);
  };

  const blockEvaluationTaskAndSetToCompleted = (transactionId) => {
    if (!evaluationTasks) {
      return;
    }

    const newEvaluationTasks = evaluationTasks.map((evaluation) => {
      return evaluation.map((task) => {
        if (task.transactionId === transactionId) {
          task.isBlocked = true;
          task.completed = true;

          if (selectedEvaluation?.transactionId === task.transactionId) {
            setSelectedEvaluation(task);
          }
        }
        return task;
      });
    });

    setEvaluationTasks(newEvaluationTasks);
  };

  const unblockEvaluationTask = (transactionId) => {
    if (!evaluationTasks) {
      return;
    }

    const newEvaluationTasks = evaluationTasks.map((evaluation) => {
      return evaluation.map((task) => {
        if (task.transactionId === transactionId) {
          task.isBlocked = false;
        }
        return task;
      });
    });

    setEvaluationTasks(newEvaluationTasks);
  };

  if (isPageLoading) {
    return (
      <div className={styles['container']}>
        <LoadingSpinner show size="large" className={styles['spinner']}/>
      </div>
    );
  }

  if (selectedEvaluation) {
    return (
      <EvaluationExperience
        evaluationPage={evaluationPage}
        evaluationTaskGroup={selectedEvaluation}
        areRetakesEnabled={areRetakesEnabled}
        isCustomTextEnabled={isCustomTextEnabled}
        brandId={brandId}
        onSurveySubmission={onSurveySubmission}
        evaluations={evaluationTasks}
        setSelectedEvaluation={setSelectedEvaluation}
      />
    );
  }

  return (
    <HomePage 
      isPageLoading={isPageLoading}
      evaluationPage={evaluationPage}
      evaluationTasks={evaluationTasks}
      areRetakesEnabled={areRetakesEnabled}
      brandId={brandId}
      hashedStudentId={hashedStudentId}
      setSelectedEvaluation={setSelectedEvaluation}
      studentId={studentId}
    />
  );
};

export default EvaluationExperienceStudentPortal;
